import { api } from "./configs/axiosConfigs"

export const BankAPI = {
    get: async (data?: object) => {
        const response = await api.get(
            '/bank', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },
}